var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultSchoolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3028 45.0694L23.6378 43.2544C22.6779 42.8797 21.8536 42.2238 21.2728 41.3727C20.692 40.5215 20.3818 39.5148 20.3828 38.4844V30.1444L29.9978 24.6094L39.5978 30.1894V38.5594C39.6015 39.5825 39.2973 40.5831 38.7248 41.431C38.1524 42.279 37.3381 42.9352 36.3878 43.3144L32.0828 44.9944C30.8796 45.5058 29.5254 45.5327 28.3028 45.0694Z",
    fill: "#5981FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8781 21.3525L32.3831 15.3525C31.587 14.8521 30.6625 14.5941 29.7222 14.6101C28.782 14.6261 27.8668 14.9153 27.0881 15.4425L17.9981 21.5775C17.3422 22.0179 16.8048 22.6129 16.4332 23.31C16.0616 24.0072 15.8672 24.785 15.8672 25.575C15.8672 26.365 16.0616 27.1429 16.4332 27.84C16.8048 28.5372 17.3422 29.1322 17.9981 29.5725L27.3131 35.7675C28.1101 36.3073 29.0506 36.5958 30.0131 36.5958C30.9757 36.5958 31.9161 36.3073 32.7131 35.7675L41.7131 29.6175V34.3275C41.7131 34.6259 41.8316 34.912 42.0426 35.123C42.2536 35.334 42.5398 35.4525 42.8381 35.4525C43.1365 35.4525 43.4226 35.334 43.6336 35.123C43.8446 34.912 43.9631 34.6259 43.9631 34.3275V26.5125C44.1993 25.5424 44.1252 24.5227 43.7511 23.5969C43.3771 22.6712 42.722 21.8862 41.8781 21.3525Z",
    fill: "#5981FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSchoolLogo);
export default __webpack_public_path__ + "static/media/DefaultSchoolLogo.09c648adb26e62f9e93faf9e40894cac.svg";
export { ForwardRef as ReactComponent };